import { PricingPlan } from "@/model/interface/PricingPlan";

export const emptyPlan: Partial<PricingPlan> = {
  name: "",
  isDefault: false,
  perSeatMonthlyPriceOverride: null,
  partnerStripePriceId: null,
  outboundCallBaseRate: 0,
  inboundCallBaseRate: 0,
  outboundSmsBaseRate: 0,
  inboundSmsBaseRate: 0,
  phoneNumberBaseMonthlyRate: 0,
  outboundCallMarkupType: "PERCENTAGE",
  outboundCallMarkupAmount: 100,
  inboundCallMarkupType: "PERCENTAGE",
  inboundCallMarkupAmount: 100,
  outboundSmsMarkupType: "PERCENTAGE",
  outboundSmsMarkupAmount: 100,
  inboundSmsMarkupType: "PERCENTAGE",
  inboundSmsMarkupAmount: 100,
  phoneNumberMarkupType: "PERCENTAGE",
  phoneNumberMarkupAmount: 100,
  vapiBaseRate: 0.08,
  vapiMarkupType: "FLAT",
  vapiMarkupAmount: 0.03,
  elevenLabsConvaiBaseRate: 0.12,
  elevenLabsConvaiMarkupType: "FLAT",
  elevenLabsConvaiMarkupAmount: 0.04,
  nativeAiBaseRate: 0.2,
  nativeAiMarkupType: "FLAT",
  nativeAiMarkupAmount: 0.1,
  recordingStorageBaseRate: 0.001,
  recordingStorageMarkupType: "FLAT",
  recordingStorageMarkupAmount: 0.004,
  machineDetectionBaseRate: 0.0075,
  machineDetectionMarkupType: "FLAT",
  machineDetectionMarkupAmount: 0.0025,
  deepgramTranscriptionBaseRate: 0.0043,
  deepgramTranscriptionMarkupType: "FLAT",
  deepgramTranscriptionMarkupAmount: 0.0057,
  lineTypeLookupBaseRate: 0.008,
  lineTypeLookupMarkupType: "FLAT",
  lineTypeLookupMarkupAmount: 0.002,
  callerIdLookupBaseRate: 0.01,
  callerIdLookupMarkupType: "FLAT",
  callerIdLookupMarkupAmount: 0.01,
  datazappDncBaseRate: 0.005,
  datazappDncMarkupType: "FLAT",
  datazappDncMarkupAmount: 0.005,
  tracerfyDncBaseRate: 0.02,
  tracerfyDncMarkupType: "FLAT",
  tracerfyDncMarkupAmount: 0.01,
  skipTraceBaseRate: 0.02,
  skipTraceMarkupType: "FLAT",
  skipTraceMarkupAmount: 0.04,
  skipTraceBulkMarkupAmount: 0.02,
  skipTraceBulkMinimum: 3,
  twoFactorSmsBaseRate: 0.0083,
  twoFactorSmsMarkupType: "FLAT",
  twoFactorSmsMarkupAmount: 0.0017,
  twoFactorVerificationBaseRate: 0.05,
  twoFactorVerificationMarkupType: "FLAT",
  twoFactorVerificationMarkupAmount: 0,
  a2pAssistedRegistrationFee: 199,
  a2pBrandBaseRate: 44,
  a2pBrandMarkupType: "FLAT",
  a2pBrandMarkupAmount: 1,
  a2pBrandLowVolumeBaseRate: 4,
  a2pBrandLowVolumeMarkupType: "FLAT",
  a2pBrandLowVolumeMarkupAmount: 0.5,
  a2pCampaignVettingBaseRate: 15,
  a2pCampaignVettingMarkupType: "FLAT",
  a2pCampaignVettingMarkupAmount: 1,
  a2pCampaignStandardBaseRate: 10,
  a2pCampaignLowVolumeBaseRate: 1.5,
  a2pCampaignSoleProprietorBaseRate: 2,
};
